<div [class.has-background]="hasBackground" [formGroup]="form" class="wrapper">
	<div (click)="selectCountryCode()" [class.custom]="customStyle" class="country-code">
		<div class="flag-container">
			<ion-img [src]="'../../../../assets/flag/flags-country/' + flag + '.svg'" class="flag"></ion-img>
		</div>
		{{ form.get('country')?.value }}
		<ion-img class="arrow" src="../../../assets/topgolf/arrow-right.svg"></ion-img>
	</div>
	<ion-input
		(ionBlur)="onPhoneBlur()"
		[class.custom]="customStyle"
		formControlName="phone"
		lines="none"
		placeholder="345345345"
		type="number"
	></ion-input>
</div>
